module.exports = __webpack_public_path__ + "static/media/item_20_1_comp.6ee0a829.png";